<template>
  <div>
    <gg-modal :is-active="showModal" @close="clickSkipForNow">
      <template v-slot:body>
        <div class="text-right" style="margin-right: -15px;">
          <gg-btn icon text class="text-none" @click="clickSkipForNow">
            <v-icon :color="'green'" class="pa-2">
              mdi-close
            </v-icon>
          </gg-btn>
        </div>
        <v-row>
          <v-col cols="12">
            <div class="text-center">
              <div style="background-color: #DBFCE7; border-radius: 36px; width: fit-content; display: block; margin: auto">
                <v-icon size="36px" :color="'green'" class="pa-2">
                  mdi-shield-outline
                </v-icon>
              </div>
            </div>
          </v-col>
          <v-col cols="12" class="text-center pb-1">
            <h3 class="text-center text-black" style="color: black !important;">
              Secure Your Account with 2FA
            </h3>
          </v-col>
          <v-col cols="12" class="text-center pt-0">
            Two-factor authentication adds an extra layer of security to your GreenGeeks account, protecting your websites and domains
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1">
            <v-icon class="mb-1" :color="'green'">
              mdi-check
            </v-icon>
          </v-col>
          <v-col cols="11">
            <div style="color: black !important;">Enhanced Security</div>
            <div>Protect your account from unauthorized access even if your password is compromised</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1">
            <v-icon class="mb-1" :color="'green'">
              mdi-lock-outline
            </v-icon>
          </v-col>
          <v-col cols="11">
            <div style="color: black !important;">Easy Setup</div>
            <div>Set up in minutes using your smartphone and an authenticator app</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1">
            <v-icon class="mb-1" :color="'green'">
              mdi-shield-outline
            </v-icon>
          </v-col>
          <v-col cols="11">
            <div style="color: black !important;">Industry Standard</div>
            <div>Join millions of users who trust 2FA to keep their accounts safe</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <gg-btn primary @click="open2FAModal" style="width: 100%">
              Enable Two-Factor Authentication
            </gg-btn>
          </v-col>
          <v-col cols="6">
            <gg-btn secondary @click="clickRemindMeLater" style="width: 100%">Remind Me in 10 Days</gg-btn>
          </v-col>
          <v-col cols="6">
            <gg-btn secondary @click="clickSkipForNow" style="width: 100%">Skip for Now</gg-btn>
          </v-col>
        </v-row>
      </template>
    </gg-modal>
    <two-factor-auth-modal :show="modal2FA" @close="close2FAModal"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TwoFactorAuthModal from 'Components/Profile/Security/TwoFactorAuth/TwoFactorAuthModal'

export default {
  name: 'TwoFaEnableModal',

  components: {
    TwoFactorAuthModal,
  },

  data: () => ({
    modal: true,
    modal2FA: false,
    remindLaterPeriod: 10 * 24 * 60 * 60 * 1000,
  }),

  computed: {
    ...mapGetters(['SessionProfile', 'remind2FA']),
    isEnabled () {
      return !!this.SessionProfile.totp_enabled
    },
    showModal () {
      if (this.SessionProfile.totp_enabled) {
        return false
      }
      return !this.remind2FA.showed && this.remind2FA.remindAfter < Date.now()
    },
  },

  methods: {
    ...mapActions(['enableAutorenew', 'setRemind2FA']),
    openModal () {
      this.modal = true
    },
    closeModal () {
      this.modal = false
      this.$emit('close')
    },
    clickRemindMeLater () {
      this.setRemind2FA({ showed: true, remindAfter: Date.now() + this.remindLaterPeriod })
    },
    clickSkipForNow () {
      this.setRemind2FA({ showed: true, remindAfter: Date.now() })
    },
    open2FAModal () {
      this.modal2FA = true
    },
    close2FAModal () {
      this.modal2FA = false
    },
  },

}
</script>

<style scoped></style>
